import { render, staticRenderFns } from "./skyTextarea.vue?vue&type=template&id=fe1def04"
import script from "./skyTextarea.vue?vue&type=script&lang=js"
export * from "./skyTextarea.vue?vue&type=script&lang=js"
import style0 from "./skyTextarea.vue?vue&type=style&index=0&id=fe1def04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports